import React from 'react'

import * as styles from './styles.module.scss'

/**
 *
 */
export const Container = ({ className, children, props }) => <>{children}</>
